import * as React from "react";
import { connect } from "react-redux";
import { Path as RoutePath } from "../../../path";
import { ApplicationState, FetchState, actionCreators, selectors } from "../../../store";
import './styles.css';

import CachedIcon from '@mui/icons-material/Cached';
import { Button, Card, CardContent, CardHeader, CircularProgress, FormControl, Grid, IconButton, MenuItem, Select, Stack, Typography } from "@mui/material";
import { Auth } from "aws-amplify";
import axios from 'axios';
import { push } from "connected-react-router";
import { useNavigate, useParams } from "react-router";
import { ConfirmTimeModel, ConnectionConfigInfoModel, Cpn30MinutePowerConsumptionModel, Cpn4GLteSettingModel, DemandCurrentDataModel, DemandSettingDataModel, DeviceNameModel, ExcessHeavyLeakageCurrentModel, ExcessLightLeakageCurrentModel, HeavyEarthLeakageSettingModel, LeakageInformationModel, LightLeakageSettingModel, LocationNameModel, MaximumEarthLeakageModel, SettingInformationModel, SoftVersionDataModel } from "../../../models";
import { deviceTypeOptions } from "../../../statics";
import palette from '../../../theme/palette';
import FetchHelper from "../../FetchHelper";
import DeviceInformation from "../device/DeviceInformation";
import ConfirmTimeDialog from "../pollingTopicDetails_JSPDevice/ConfirmTimeDialog";
import Cpn30MinutePowerConsumption_TJ360VersionDevice from "./30MinutePowerConsumption_TJ360VersionDevice";
import Cpn4GLteSetting_TJ360VersionDevice from "./4GLteSetting_TJ360VersionDevice";
import ChangeMeasurentStartedEnd_TJ360VersionDevice from "./ChangeMeasurentStartedEnd_TJ360VersionDevice";
import ConfirmTime_TJ360VersionDevice from "./ConfirmTime_TJ360VersionDevice";
import ConnectionConfigInfo_TJ360VersionDevice from "./ConnectionConfigInfo_TJ360VersionDevice";
import DemandChangeStartEnd_TJ360VersionDevice from "./DemandChangeStartEnd_TJ360VersionDevice";
import DemandCurrentData_TJ360VersionDevice from "./DemandCurrentData_TJ360VersionDevice";
import DemandSettingData_TJ360VersionDevice from "./DemandSettingData_TJ360VersionDevice";
import DeviceName_TJ360VersionDevice from "./DeviceName_TJ360VersionDevice";
import ExcessHeavyLeakageCurrent_TJ360VersionDevice from "./ExcessHeavyLeakageCurrent_TJ360VersionDevice";
import ExcessLightLeakageCurrent_TJ360VersionDevice from "./ExcessLightLeakageCurrent_TJ360VersionDevice";
import HeavyEarthLeakageSetting_TJ360VersionDevice from "./HeavyEarthLeakageSetting_TJ360VersionDevice";
import LeakageInformation_TJ360VersionDevice from "./LeakageInformation_TJ360VersionDevice";
import LightLeakageSetting_TJ360VersionDevice from "./LightLeakageSetting_TJ360VersionDevice";
import LocationName_TJ360VersionDevice from "./LocationName_TJ360VersionDevice";
import LoRaConnectionStatus_TJ360VersionDevice, { ConnectionInfomationModel } from "./LoRaConnectionStatus_TJ360VersionDevice";
import MaximumEarthLeakage_TJ360VersionDevice from "./MaximumEarthLeakage_TJ360VersionDevice";
import PhaseAngleInformation_TJ360VersionDevice, { PhaseAngleInformation_TJ360VersionDeviceModel } from "./PhaseAngleInformation_TJ360VersionDevice";
import SettingInformation_TJ360VersionDevice from "./SettingInformation_TJ360VersionDevice";
import SoftVersionData_TJ360VersionDevice from "./SoftVersionData_TJ360VersionDevice";

const menusFetchId = 'MENUS_FETCH';
const demandCurrentDataFetchId = "DEMAND_CURRENT_DATA_FETCH";
const demandSettingDataFetchId = "DEMAND_SETTING_DATA_FETCH";
const leakageInformationFetchId = "LEAKAGE_INFORMATION_FETCH";
const connectionInformationFetchId = "CONNECTION_INFORMATION_FETCH";
const connectionConfigInfoFetchId = "CONNECTION_CONFIG_INFO_FETCH";
const lightLeakageSettingFetchId = "LIGHT_LEAKAGE_SETTING_FETCH";
const heavyEarthLeakageSettingFetchId = "HEAVY_EARTH_LEAKAGE_SETTING_FETCH";
const relayZCTSettingFetchId = "RELAY_ZCT_SETTING_FETCH";
const confirmTimeFetchId = "CONFIRM_TIME_FETCH";
const settingInformationFetchId = "SETTING_INFORMATION_FETCH";
const phaseAngleInformationFetchId = "PHASE_ANGLE_INFORMATION_FETCH";
const excessLightLeakageCurrentFetchId = "EXCESS_LIGHT_LEAKAGE_CURRENT_FETCH";
const excessHeavyLeakageCurrentFetchId = "EXCESS_HEAVY_LEAKAGE_CURRENT_FETCH";
const maximumEarthLeakageFetchId = "MAXIMUM_EARTH_LEAKAGE_FETCH";
const earthFaultAlarmSettingFetchId = "EARTH_FAULT_ALARM_SETTING_FETCH";
const deviceNameFetchId = "DEVICE_NAME_FETCH";
const locationNameFetchId = "LOCATION_NAME_FETCH";
const loRaSettingFetchId = "LORA_SETTING_FETCH";
const data4GLteSettingFetchId = "DATA_4G_LTE_SETTING_FETCH";
const updateConfirmTimeFetchId = "UPDATE_CONFIRM_TIME_FETCH_ID";
const softVersionDataFetchId = "SOFT_VERSION_DATA_FETCH";

// -------------
// Props
export type PollingTopicDetails_TJ360VersionDeviceProps = ReturnType<typeof mapStateToProps> &
    typeof mapDispatchToProps;
// -------------
// Component
export const PollingTopicDetails_TJ360VersionDevice = (props: PollingTopicDetails_TJ360VersionDeviceProps) => {
    let { id } = useParams();
    let navigate = useNavigate();
    const isVisibleRefreshAllButton = process.env.REACT_APP_POLLING_ALL_UPDATE_BUTTON_VISIBLE;
    const { fetchStateMenu, onUpdateSuccess, onUpdateError, onGetAuthRole, onUpdate, onError, onSearch } = props;
    //遷移ボタンのdivタグのref変数
    const myRef1 = React.useRef<any>(null);
    const myRef2 = React.useRef<any>(null);
    const myRef3 = React.useRef<any>(null);
    const myRef4 = React.useRef<any>(null);
    const myRef5 = React.useRef<any>(null);
    const myRef6 = React.useRef<any>(null);
    const myRef7 = React.useRef<any>(null);
    const myRef8 = React.useRef<any>(null);
    const myRef9 = React.useRef<any>(null);
    const myRef10 = React.useRef<any>(null);
    const myRef11 = React.useRef<any>(null);
    const myRef12 = React.useRef<any>(null);
    const myRef13 = React.useRef<any>(null);
    const myRef14 = React.useRef<any>(null);
    const myRef15 = React.useRef<any>(null);
    const myRef16 = React.useRef<any>(null);
    const myRef17 = React.useRef<any>(null);
    const myRef18 = React.useRef<any>(null);
    const myRef30MinutesPowerRequirement = React.useRef<any>(null); // REF21
    const myRefSoftVersion = React.useRef<any>(null);

    const [activeRef, setActiveRef] = React.useState(1);
    const [isOnScroll, setIsOnScroll] = React.useState(false);
    const [loadingRefreshAll, setLoadingRefreshAll] = React.useState<any>(new Array(18).fill('').map(() => false));
    const [isEdit, setIsEdit] = React.useState(false);
    const [device, setDevice] = React.useState<any>();
    const [countFetch, setCountFetch] = React.useState(0);
    const [disableAllRefeshButton, setDisableAllRefeshButton] = React.useState(true);
    const [disableAllUpdateButton, setDisableAllUpdateButton] = React.useState(true);
    const [deviceNo, setDeviceNo] = React.useState("00");
    const [openDialog,setOpenDialog] = React.useState<boolean>(false);
    const [loadingFlag, setLoadingFlag] = React.useState<boolean>(true);
    const [updateData, setUpdateData] = React.useState<any>();
    const [isRefreshSuccessDeviceNo, setIsRefreshSuccessDeviceNo] = React.useState<boolean>(false);

    const deviceNoOptions = Array(100).fill('').map((_, index) => 
        index.toString().padStart(2, '0')
    );
    
    React.useEffect(() => {
        if(fetchStateMenu.data){
            setDisableAllRefeshButton(!fetchStateMenu.data.auth_role_map['GW-gwstatus-get'])
            setDisableAllUpdateButton(!fetchStateMenu.data.auth_role_map['GW-gwstatus-update'])
        } else {
            onGetAuthRole()
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const handleFetchAuthRoleSuccess = (data: any) => {
        console.log('>>> handleSuccess');
        if (data){
            setDisableAllRefeshButton(!data.auth_role_map['GW-gwstatus-get'])
            setDisableAllUpdateButton(!data.auth_role_map['GW-gwstatus-update'])
        }
    }

    const handleUpdateSuccess = (success:any, data:any, error:any) => {
        const result = {
            mainid: data.mainid,
            resultCode: data.result_code,
            last_get_datetime: data.last_get_datetime,
        };
        if (result.resultCode === '0') {
            onUpdateSuccess();
            handleRefreshGroup(confirmTimeFetchId, '時間確認')
        } else {
            handleUpdateError(success, data, error);
        }
    }

    const handleUpdateError = (success: boolean, data: any, error: any) => {
        onUpdateError(success, data, error);
    }

    //移動関数
    const scrollTo = (value: String) => {
        if (value === "デマンド現在値") {
            myRef1.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(1);
        }
        if (value === "デマンド設定値") {
            myRef2.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(2);
        }
        if (value === "デマンド開始終了変更") {
            myRef3.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(3);
        }

        if(value === "測定値開始終了変更"){
            myRef4.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(4);
        }

        if (value === "Connection情報") {
            myRef5.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(5);
        }
        if (value === "漏電情報") {
            setActiveRef(6);
            myRef6.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "軽漏電設定") {
            setActiveRef(7);
            myRef7.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "重漏電設定") {
            setActiveRef(8);
            myRef8.current.scrollIntoView({ behavior: 'auto' });
        }
        if(value === "30分電力量要求"){
            setActiveRef(21);
            myRef30MinutesPowerRequirement.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "時間確認") {
            setActiveRef(9);
            myRef9.current.scrollIntoView({ behavior: 'auto' });
        }
        if(value === "SoftVersion情報"){
            setActiveRef(20);
            myRefSoftVersion.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "Io/Ior設定情報") {
            setActiveRef(10);
            myRef10.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "PhaseAngle情報") {
            setActiveRef(11);
            myRef11.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "軽漏電流超過・復帰時間") {
            setActiveRef(12);
            myRef12.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "重漏電流超過・復帰時間") {
            setActiveRef(13);
            myRef13.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "最大漏電") {
            setActiveRef(14);
            myRef14.current.scrollIntoView({ behavior: 'auto' });
        }
        if (value === "DeviceName") {
            setActiveRef(15);
            myRef15.current.scrollIntoView({ behavior: 'auto' });
            setIsOnScroll(true);
        }
        if (value === "LocationName") {
            setActiveRef(16);
            myRef16.current.scrollIntoView({ behavior: 'auto' });
            setIsOnScroll(true);
        }
        if (value === "Connection設定情報") {
            myRef17.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(17);
            setIsOnScroll(true);
        }
        if (value === "4G LTE設定") {
            myRef18.current.scrollIntoView({ behavior: 'auto' });
            setActiveRef(18);
            setIsOnScroll(true);
        }
    }

    const handleScroll = (event: React.UIEvent<HTMLElement>) => {
        let offsetTop = event.currentTarget.scrollTop + myRef1.current.offsetTop;
        if (isOnScroll) {
            setIsOnScroll(false);
            return;
        }
        if (offsetTop < myRef2.current.offsetTop) {
            setActiveRef(1);
        } else if (offsetTop >= myRef2.current.offsetTop && offsetTop < myRef3.current.offsetTop) {
            setActiveRef(2);
        } else if (offsetTop >= myRef3.current.offsetTop && offsetTop < myRef4.current.offsetTop) {
            setActiveRef(3);
        } else if (offsetTop >= myRef4.current.offsetTop && offsetTop < myRef5.current.offsetTop) {
            setActiveRef(4);
        } else if (offsetTop >= myRef5.current.offsetTop && offsetTop < myRef6.current.offsetTop) {
            setActiveRef(5);
        } else if (offsetTop >= myRef6.current.offsetTop && offsetTop < myRef7.current.offsetTop) {
            setActiveRef(6);
        } else if (offsetTop >= myRef7.current.offsetTop && offsetTop < myRef8.current.offsetTop) {
            setActiveRef(7);
        } else if (offsetTop >= myRef8.current.offsetTop && offsetTop < myRef30MinutesPowerRequirement.current.offsetTop){
            setActiveRef(8);
        } else if(offsetTop >= myRef30MinutesPowerRequirement.current.offsetTop && offsetTop < myRef9.current.offsetTop){
            setActiveRef(21);
        }        
        else if(offsetTop >= myRef9.current.offsetTop && offsetTop < myRefSoftVersion.current.offsetTop){
            setActiveRef(9);
        }
          else if (offsetTop >= myRefSoftVersion.current.offsetTop && offsetTop < myRef10.current.offsetTop) {
            setActiveRef(20);
        } else if (offsetTop >= myRef10.current.offsetTop && offsetTop < myRef11.current.offsetTop) {
            setActiveRef(10);
        } else if (offsetTop >= myRef11.current.offsetTop && offsetTop < myRef12.current.offsetTop) {
            setActiveRef(11);
        } else if (offsetTop >= myRef12.current.offsetTop && offsetTop < myRef13.current.offsetTop) {
            setActiveRef(12);
        } else if (offsetTop >= myRef13.current.offsetTop && offsetTop < myRef14.current.offsetTop) {
            setActiveRef(13);
        } else if (offsetTop >= myRef14.current.offsetTop && offsetTop < myRef15.current.offsetTop) {
            setActiveRef(14);
        }        
        else if (offsetTop >= myRef15.current.offsetTop && offsetTop < myRef16.current.offsetTop) {
            setActiveRef(15);
        } else if (offsetTop >= myRef16.current.offsetTop && offsetTop < myRef17.current.offsetTop) {
            setActiveRef(16);
        } else if (offsetTop >= myRef17.current.offsetTop && offsetTop < myRef18.current.offsetTop) {
            setActiveRef(17);
        } else if (offsetTop >= myRef18.current.offsetTop) {
            setActiveRef(18);
        }
    }

    const liStyles = {
        cursor: 'pointer',
        width: '80%',
        marginBottom: '3px',
        color: '#1890ff',
        backgroundColor: palette.action.hover,
        alignItems: 'center',
    }

    const liStylesNormal = {
        cursor: 'pointer',
        width: '80%',
        marginBottom: '3px',
    }

    const menuStyles = {
        width: '85%',
        display: 'flex',
        justifyContent: 'space-between',
    }

    const [numberRefreshAll, setNumberRefreshAll] = React.useState(0);
    const handleRefresh = () => {
        setNumberRefreshAll(1);
        setLoadingRefreshAll(loadingRefreshAll.map(() => true));
    };

    const handleRefreshGroup = (fetchId: string, scrollToName: string) => {
        scrollTo(scrollToName);
        switch (fetchId) {
            case demandCurrentDataFetchId:
                setDemandCurrentDataRefresh(true);
                break;
            case demandSettingDataFetchId:
                setDemandSettingDataRefresh(true);
                break;
            case leakageInformationFetchId:
                setLeakageInformationRefresh(true);
                break;
            case connectionInformationFetchId:
                setLoRaConnectionStatusRefresh(true);
                break;
            case connectionConfigInfoFetchId:
                setConnectionConfigInfoRefresh(true);
                break;
            case lightLeakageSettingFetchId:
                setLightLeakageSettingRefresh(true);
                break;
            case heavyEarthLeakageSettingFetchId:
                setHeavyEarthLeakageSettingRefresh(true);
                break;
            case confirmTimeFetchId:
                setConfirmTimeRefresh(true);
                break;
            case softVersionDataFetchId:
                setSoftVersionDataRefresh(true);
                break;
            case settingInformationFetchId:
                setSettingInformationRefresh(true);
                break;
            case phaseAngleInformationFetchId:
                setPhaseAngleInformationRefresh(true);
                break;
            case excessLightLeakageCurrentFetchId:
                setExcessLightLeakageCurrentRefresh(true);
                break;
            case excessHeavyLeakageCurrentFetchId:
                setExcessHeavyLeakageCurrentRefresh(true);
                break;
            case maximumEarthLeakageFetchId:
                setMaximumEarthLeakageRefresh(true);
                break;
            case deviceNameFetchId:
                setDeviceNameRefresh(true);
                break;
            case locationNameFetchId:
                setLocationNameRefresh(true);
                break;
            case data4GLteSettingFetchId:
                setData4GLteSettingRefresh(true);
                break;
        }
    }

    // キャンセル
    const handleCancel = () => navigate(RoutePath.DeviceList);

    const handleRefreshAll = (no: number) => {
        setNumberRefreshAll(no);
    }

    const disabledRefreshAllBtnStyle = {
        fontSize: 24,
        color: 'gray',
    }

    const enableRefreshAllBtnStyle = {
        fontSize: 24,
        color: '#1890ff',
    }

    const handleSetIsEdit = (isEditRes: boolean) => {
        setIsEdit(isEditRes);
    }

    const [disabledRefreshAll, setDisabledRefreshAll] = React.useState<boolean>(false);
    const [disabledDemandCurrentDataRefresh, setDisabledDemandCurrentDataRefresh] = React.useState<boolean>(false);
    const [disabledDemandSettingDataRefresh, setDisabledDemandSettingDataRefresh] = React.useState<boolean>(false);
    const [disabledLeakageInformationRefresh, setDisabledLeakageInformationRefresh] = React.useState<boolean>(false);
    const [disabledLightLeakageSettingRefresh, setDisabledLightLeakageSettingRefresh] = React.useState<boolean>(false);
    const [disabledHeavyEarthLeakageSettingRefresh, setDisabledHeavyEarthLeakageSettingRefresh] = React.useState<boolean>(false);
    const [disabledConfirmTimeRefresh, setDisabledConfirmTimeRefresh] = React.useState<boolean>(false);
    const [disabledSoftVersionDataRefresh, setDisabledSoftVersionDataRefresh] = React.useState<boolean>(false);
    const [disabledSettingInformationRefresh, setDisabledSettingInformationRefresh] = React.useState<boolean>(false);
    const [disabledPhaseAngleInformationRefresh, setDisabledPhaseAngleInformationRefresh] = React.useState<boolean>(false);
    const [disabledExcessLightLeakageCurrentRefresh, setDisabledExcessLightLeakageCurrentRefresh] = React.useState<boolean>(false);
    const [disabledExcessHeavyLeakageCurrentRefresh, setDisabledExcessHeavyLeakageCurrentRefresh] = React.useState<boolean>(false);
    const [disabledMaximumEarthLeakageRefresh, setDisabledMaximumEarthLeakageRefresh] = React.useState<boolean>(false);
    const [disabledEarthFaultAlarmSettingRefresh, setDisabledEarthFaultAlarmSettingRefresh] = React.useState<boolean>(false);
    const [disabledDeviceNameRefresh, setDisabledDeviceNameRefresh] = React.useState<boolean>(false);
    const [disabledLocationNameRefresh, setDisabledLocationNameRefresh] = React.useState<boolean>(false);
    const [disabledLoRaSettingRefresh, setDisabledLoRaSettingRefresh] = React.useState<boolean>(false);
    const [disabledData4GLteSettingRefresh, setDisabledData4GLteSettingRefresh] = React.useState<boolean>(false);
    const [disabledConnectionInformationRefresh, setDisabledConnectionInformationRefresh] = React.useState<boolean>(false);
    const [disabledConnectionConfigInfoRefresh, setDisabledConnectionConfigInfoRefresh] = React.useState<boolean>(false);
    const [disabledRelayZCTSettingRefresh, setDisabledRelayZCTSettingRefresh] = React.useState<boolean>(false);

    const handleSetDisabledRefreshGroupBtn = (isDisabled: boolean, name: string) => {
        switch (name) {
            case demandCurrentDataFetchId:
                setDisabledDemandCurrentDataRefresh(isDisabled);
                break;
            case demandSettingDataFetchId:
                setDisabledDemandSettingDataRefresh(isDisabled);
                break;
            case leakageInformationFetchId:
                setDisabledLeakageInformationRefresh(isDisabled);
                break;
            case connectionInformationFetchId:
                setDisabledConnectionInformationRefresh(isDisabled);
                break;
            case connectionConfigInfoFetchId:
                setDisabledConnectionConfigInfoRefresh(isDisabled);
                break;
            case lightLeakageSettingFetchId:
                setDisabledLightLeakageSettingRefresh(isDisabled);
                break;
            case heavyEarthLeakageSettingFetchId:
                setDisabledHeavyEarthLeakageSettingRefresh(isDisabled);
                break;
            case confirmTimeFetchId:
                setDisabledConfirmTimeRefresh(isDisabled);
                break;
            case softVersionDataFetchId:
                setDisabledSoftVersionDataRefresh(isDisabled);
                break;
            case settingInformationFetchId:
                setDisabledSettingInformationRefresh(isDisabled);
                break;
            case phaseAngleInformationFetchId:
                setDisabledPhaseAngleInformationRefresh(isDisabled);
                break;
            case excessLightLeakageCurrentFetchId:
                setDisabledExcessLightLeakageCurrentRefresh(isDisabled);
                break;
            case excessHeavyLeakageCurrentFetchId:
                setDisabledExcessHeavyLeakageCurrentRefresh(isDisabled);
                break;
            case maximumEarthLeakageFetchId:
                setDisabledMaximumEarthLeakageRefresh(isDisabled);
                break;
            case earthFaultAlarmSettingFetchId:
                setDisabledEarthFaultAlarmSettingRefresh(isDisabled);
                break;
            case deviceNameFetchId:
                setDisabledDeviceNameRefresh(isDisabled);
                break;
            case locationNameFetchId:
                setDisabledLocationNameRefresh(isDisabled);
                break;
            case loRaSettingFetchId:
                setDisabledLoRaSettingRefresh(isDisabled);
                break;
            case data4GLteSettingFetchId:
                setDisabledData4GLteSettingRefresh(isDisabled);
                break;
            case relayZCTSettingFetchId:
                setDisabledRelayZCTSettingRefresh(isDisabled);
                break;
        }
    }

    const [demandCurrentDataRefresh, setDemandCurrentDataRefresh] = React.useState<boolean>(false);
    const [demandSettingDataRefresh, setDemandSettingDataRefresh] = React.useState<boolean>(false);
    const [leakageInformationRefresh, setLeakageInformationRefresh] = React.useState<boolean>(false);
    const [loRaConnectionStatusRefresh, setLoRaConnectionStatusRefresh] = React.useState<boolean>(false);
    const [connectionConfigInfoRefresh, setConnectionConfigInfoRefresh] = React.useState<boolean>(false);
    const [lightLeakageSettingRefresh, setLightLeakageSettingRefresh] = React.useState<boolean>(false);
    const [heavyEarthLeakageSettingRefresh, setHeavyEarthLeakageSettingRefresh] = React.useState<boolean>(false);
    const [confirmTimeRefresh, setConfirmTimeRefresh] = React.useState<boolean>(false);
    const [softVersionDataRefresh, setSoftVersionDataRefresh] = React.useState<boolean>(false);
    const [settingInformationRefresh, setSettingInformationRefresh] = React.useState<boolean>(false);
    const [phaseAngleInformationRefresh, setPhaseAngleInformationRefresh] = React.useState<boolean>(false);
    const [excessLightLeakageCurrentRefresh, setExcessLightLeakageCurrentRefresh] = React.useState<boolean>(false);
    const [excessHeavyLeakageCurrentRefresh, setExcessHeavyLeakageCurrentRefresh] = React.useState<boolean>(false);
    const [maximumEarthLeakageRefresh, setMaximumEarthLeakageRefresh] = React.useState<boolean>(false);
    const [deviceNameRefresh, setDeviceNameRefresh] = React.useState<boolean>(false);
    const [locationNameRefresh, setLocationNameRefresh] = React.useState<boolean>(false);
    const [data4GLteSettingRefresh, setData4GLteSettingRefresh] = React.useState<boolean>(false);
    const [demandChangeStartEnd, setDemandChangeStartEnd] = React.useState<boolean>(false);

    const handleSetDisabledRefreshAll = (isDisabled: boolean, name: string) => {
        switch (name) {
            case demandCurrentDataFetchId:
                setDemandCurrentDataRefresh(isDisabled);
                break;
            case demandSettingDataFetchId:
                setDemandSettingDataRefresh(isDisabled);
                break;
            case leakageInformationFetchId:
                setLeakageInformationRefresh(isDisabled);
                break;
            case connectionInformationFetchId:
                setLoRaConnectionStatusRefresh(isDisabled);
                break;
            case connectionConfigInfoFetchId:
                setConnectionConfigInfoRefresh(isDisabled);
                break;
            case lightLeakageSettingFetchId:
                setLightLeakageSettingRefresh(isDisabled);
                break;
            case heavyEarthLeakageSettingFetchId:
                setHeavyEarthLeakageSettingRefresh(isDisabled);
                break;
            case confirmTimeFetchId:
                setConfirmTimeRefresh(isDisabled);
                break;
            case softVersionDataFetchId:
                setSoftVersionDataRefresh(isDisabled);
                break;
            case settingInformationFetchId:
                setSettingInformationRefresh(isDisabled);
                break;
            case phaseAngleInformationFetchId:
                setPhaseAngleInformationRefresh(isDisabled);
                break;
            case excessLightLeakageCurrentFetchId:
                setExcessLightLeakageCurrentRefresh(isDisabled);
                break;
            case excessHeavyLeakageCurrentFetchId:
                setExcessHeavyLeakageCurrentRefresh(isDisabled);
                break;
            case maximumEarthLeakageFetchId:
                setMaximumEarthLeakageRefresh(isDisabled);
                break;
            case deviceNameFetchId:
                setDeviceNameRefresh(isDisabled);
                break;
            case locationNameFetchId:
                setLocationNameRefresh(isDisabled);
                break
            case data4GLteSettingFetchId:
                setData4GLteSettingRefresh(isDisabled);
                break;
        }
    }

    const handleDisabledRefreshAll = () => {
        (!disabledDemandCurrentDataRefresh && !disabledDemandSettingDataRefresh && !disabledLeakageInformationRefresh && !disabledLightLeakageSettingRefresh
            && !disabledHeavyEarthLeakageSettingRefresh && !disabledConfirmTimeRefresh && !disabledSettingInformationRefresh && !disabledPhaseAngleInformationRefresh
            && !disabledExcessLightLeakageCurrentRefresh && !disabledExcessHeavyLeakageCurrentRefresh && !disabledMaximumEarthLeakageRefresh && !disabledEarthFaultAlarmSettingRefresh && !disabledDeviceNameRefresh
            && !disabledLocationNameRefresh && !disabledLoRaSettingRefresh && !disabledData4GLteSettingRefresh && !disabledConnectionInformationRefresh && !disabledConnectionConfigInfoRefresh) && !demandChangeStartEnd && !disabledSoftVersionDataRefresh ?
            setDisabledRefreshAll(false) :
            setDisabledRefreshAll(true);
    }
    React.useEffect(handleDisabledRefreshAll, [disabledDemandCurrentDataRefresh, disabledDemandSettingDataRefresh, disabledLeakageInformationRefresh,
        disabledLightLeakageSettingRefresh, disabledHeavyEarthLeakageSettingRefresh, disabledConfirmTimeRefresh, disabledSettingInformationRefresh, disabledPhaseAngleInformationRefresh
        , disabledExcessLightLeakageCurrentRefresh, disabledExcessHeavyLeakageCurrentRefresh, disabledMaximumEarthLeakageRefresh, disabledEarthFaultAlarmSettingRefresh, disabledDeviceNameRefresh
        , disabledLocationNameRefresh, disabledLoRaSettingRefresh, disabledData4GLteSettingRefresh, disabledConnectionInformationRefresh, disabledConnectionConfigInfoRefresh, demandChangeStartEnd, disabledSoftVersionDataRefresh]);

    const handleFetchParam = (param: string, value: any) => {
        const params = new Map<string, any>();
        params.set(param, value);
        params.set('device_no', deviceNo);
        return params;
    }

    const handleFetchDeviceSuccess = (data: any) => {
        if (device?.customer_id !== data.customer_id) {
            setDevice(data);
            setCountFetch(countFetch + 1);
        }
    }

    const handleError = (success: boolean, data: any, error: any) => {
        onError(success, data, error);
        setCountFetch(countFetch + 1);
    }

    const [demandCurrentData, setDemandCurrentData] = React.useState<DemandCurrentDataModel>();
    const [demandSettingData, setDemandSettingData] = React.useState<DemandSettingDataModel>();
    const [leakageInformation, setLeakageInformation] = React.useState<LeakageInformationModel>();
    const [lightLeakageSetting, setLightLeakageSetting] = React.useState<LightLeakageSettingModel>();
    const [heavyEarthLeakageSetting, setHeavyEarthLeakageSetting] = React.useState<HeavyEarthLeakageSettingModel>();
    const [confirmTime, setConfirmTime] = React.useState<ConfirmTimeModel>();
    const [settingInformation, setSettingInformation] = React.useState<SettingInformationModel>();
    const [phaseAngleInformation, setPhaseAngleInformation] = React.useState<PhaseAngleInformation_TJ360VersionDeviceModel>();
    const [excessLightLeakageCurrent, setExcessLightLeakageCurrent] = React.useState<ExcessLightLeakageCurrentModel>();
    const [excessHeavyLeakageCurrent, setExcessHeavyLeakageCurrent] = React.useState<ExcessHeavyLeakageCurrentModel>();
    const [maximumEarthLeakage, setMaximumEarthLeakage] = React.useState<MaximumEarthLeakageModel>();
    const [deviceName, setDeviceName] = React.useState<DeviceNameModel>();
    const [locationName, setLocationName] = React.useState<LocationNameModel>();
    const [data4GLteSetting, setData4GLteSetting] = React.useState<Cpn4GLteSettingModel>();
    const [measurementInfo, setMeasurementInfo] = React.useState<any>();
    const [demandStartEndInfo, setDemandStartEndInfo] = React.useState<any>();
    const [softVersion, setSoftVersion] = React.useState<SoftVersionDataModel>();
    const [connectionInformation, setConnectionInformation] = React.useState<ConnectionInfomationModel>();
    const [thirtyMinutesPowerConsumption, setThirtyMinutesPowerConsumption] = React.useState<Cpn30MinutePowerConsumptionModel>();
    const [connectionConfigInfo, setConnectionConfigInfo] = React.useState<ConnectionConfigInfoModel>();
    
    const handleFetchSuccess = (data: any, deviceNo: string) => {
        setLoadingFlag(false);
        setIsRefreshSuccessDeviceNo(true);
        if (data.polling_info_array_count >= 0) {
            const datas = handleDefaultData(data.polling_info_array, deviceNo);
            setDemandCurrentData(datas.get('demandCurrentData'));
            setDemandSettingData(datas.get('demandSettingData'));
            setLeakageInformation(datas.get('leakageInformation'));
            setLightLeakageSetting(datas.get('lightLeakageSetting'));
            setHeavyEarthLeakageSetting(datas.get('heavyEarthLeakageSetting'));
            setConfirmTime(datas.get('confirmTime'));
            setSettingInformation(datas.get('settingInformation'));
            setPhaseAngleInformation(datas.get('phaseAngleInformation'));
            setExcessLightLeakageCurrent(datas.get('excessLightLeakageCurrent'));
            setExcessHeavyLeakageCurrent(datas.get('excessHeavyLeakageCurrent'));
            setMaximumEarthLeakage(datas.get('maximumEarthLeakage'));
            setDeviceName(datas.get('deviceName'));
            setLocationName(datas.get('locationName'));
            setData4GLteSetting(datas.get('data4GLteSetting'));
            setMeasurementInfo(datas.get("measurementInfo"));
            setDemandStartEndInfo(datas.get("demandStartEndInfo"))
            setSoftVersion(datas.get('softVersion'));
            setConnectionInformation(datas.get('connectionInformation'));
            setThirtyMinutesPowerConsumption(datas.get('thirtyMinutesPowerConsumption'));
            setConnectionConfigInfo(datas.get('connectionConfigInfo'));
        }
        setCountFetch(countFetch + 1);
    }

    const defaultDatas = [
        {
            code: 'PA',
            name: 'demandCurrentData',
        },
        {
            code: 'PB',
            name: 'demandSettingData',
        },
        {
            code: 'PH',
            name: 'leakageInformation',
        },
        {
            code: 'PI',
            name: 'lightLeakageSetting',
        },
        {
            code: 'PM',
            name: 'connectionInformation',
        },
        {
            code: 'PG',
            name: 'thirtyMinutesPowerConsumption',
        },
        {
            code: 'QJ',
            name: 'connectionConfigInfo',
        },
        {
            code: 'PK',
            name: 'heavyEarthLeakageSetting',
        },
        {
            code: 'PO',
            name: 'confirmTime',
        },
        {
            code: "PQ",
            name: 'softVersion',
        },
        {
            code: 'PU',
            name: 'settingInformation',
        },
        {
            code: 'PW',
            name: 'phaseAngleInformation',
        },
        {
            code: 'QA',
            name: 'excessLightLeakageCurrent',
        },
        {
            code: 'QC',
            name: 'excessHeavyLeakageCurrent',
        },
        {
            code: 'QE',
            name: 'maximumEarthLeakage',
        },
        {
            code: 'QR',
            name: 'MicroEarthFaultLowerLimitDetection',
        },
        {
            code: 'QS',
            name: 'MinorGroundFaultWarningDetection',
        },
        {
            code: 'QT',
            name: 'MinorGroundFaultAlarm',
        },
        {
            code: 'QF',
            name: 'deviceName',
        },
        {
            code: 'QH',
            name: 'locationName',
        },
        {
            code: 'QL',
            name: 'data4GLteSetting',
        },
        {
            code: 'PY',
            name: 'measurementInfo',
        },
        {
            code: 'PF',
            name: 'demandStartEndInfo',
        },
    ];
    const handleDefaultData = (data: any, deviceNo: string) => {
        const results = new Map<string, any>();
        defaultDatas.forEach(item => {
            const object = data.find((pollingInfo: any) => pollingInfo.code === item.code);
            if (object) {
                if (object.device_no === null) {
                    object && object.data && results.set(item.name, JSON.parse(object.data));
                } else {
                    const device = data.find((pollingInfo: any) => pollingInfo.code === item.code && pollingInfo.device_no === deviceNo);
                    device && device.data && results.set(item.name, JSON.parse(device.data));
                }
            }
        });
        return results;
    }

    const handleEditOk = (request:any) => {
        setOpenDialog(false);
        const requestData = {
            mainid: request.mainid,
            year: request.year,
            month: request.month,
            day: request.day,
            hour: request.hour,
            minute: request.minute,
            device_no: deviceNo,
            centralid: device?.centralid ?? ''
        }
        onUpdate(requestData);
        setUpdateData(request);
    }

    return (
        <>
            <FetchHelper 
                fetchId={menusFetchId} 
                onComplete={(success, data, error) =>
                    success ? handleFetchAuthRoleSuccess(data) : handleError(success, data, error)} 
            />
            <FetchHelper fetchId={'DEVICE_FETCH'}
                url={"/master/gateways/get"}
                method="GET"
                request={true}
                params={handleFetchParam('id', id)}
                onComplete={(success, data, error) => {
                    success ? handleFetchDeviceSuccess(data) : handleError(success, data, error)
                }}
            />
            <FetchHelper fetchId={'CACHE_FETCH'}
                url={"/polling-nrf/cache"}
                method="GET"
                request={true}
                params={handleFetchParam('mainid', id)}
                onComplete={(success, data, error) => {
                    success ? handleFetchSuccess(data, deviceNo) : handleError(success, data, error)
                }}
            />
            {(loadingFlag) && (
                <div style={{ top: "0px", left: '0px', position: "fixed", zIndex: 1200, width: '100%', height: '100%', padding: '50vh 50% 50% 50%', background: '#00000030' }}>
                    <CircularProgress />
                </div>
            )}
            <DeviceInformation deviceInformation={device} mainid={id ?? ''} title="状態設定値" isDisplayDeviceInfo={true} isShowMenuButton={true} ></DeviceInformation>
            <Card style={{ width: '85%', margin: '12px auto auto auto', boxShadow: '1px 1px 1px 1px #bfbfbf', paddingBottom: '0', height: 'calc(100vh - 210px)',overflowY:"auto", minHeight: '600px' }}>
                {
                    isVisibleRefreshAllButton != 'true' && 
                    <CardHeader
                        titleTypographyProps={{ variant: 'h4' }}
                        title={`監視装置　状態設定値：${deviceTypeOptions[1].label}`}
                        sx={{ paddingBottom: '0px' }}
                    />
                }
                {
                    isVisibleRefreshAllButton == 'true' && 
                    <CardHeader
                        action={
                            <div>
                                <IconButton aria-label="refresh" onClick={handleRefresh} disabled={numberRefreshAll > 0 || isEdit || disabledRefreshAll}>
                                    <CachedIcon style={numberRefreshAll > 0 || isEdit || disabledRefreshAll ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                </IconButton>
                            </div>
                        }
                        sx={{ paddingBottom: '0px' }}
                        titleTypographyProps={{ variant: 'h4' }}
                        title={`監視装置　状態設定値：${deviceTypeOptions[1].label}`}
                    />
                }

                <CardContent>
                    <Grid container mb={2} direction="row" alignItems="center">
                        <Typography variant="h6">端末番号：</Typography>
                        <FormControl size="small" >
                            <Select
                                sx={{ minWidth: "65px" }}
                                size="small"
                                onChange={async (event) => {
                                    setLoadingFlag(true);
                                    try {
                                        const session = await Auth.currentSession();
                                        const url1 = process.env.REACT_APP_APIGW_URL + `/polling-nrf/cache?mainid=${device.id}&device_no=${deviceNo}`;
                                        const token = session.getIdToken().getJwtToken();
                                        const data1 = await axios.get(url1, {
                                            headers: {
                                                'Authorization': token,
                                            }
                                        });
                                        if (data1 && data1.status == 200) {
                                            handleFetchSuccess(data1.data, deviceNo);
                                        }else{
                                        }
                                        setIsRefreshSuccessDeviceNo(false);
                                        setDeviceNo(event.target.value);
                                        setLoadingFlag(true);
                                        const url2 = process.env.REACT_APP_APIGW_URL + `/polling-nrf/cache?mainid=${device.id}&device_no=${event.target.value}`;
                                        const data2 = await axios.get(url2, {
                                            headers: {
                                                'Authorization': token,
                                            }
                                        });
                                        if (data2 && data2.status == 200) {
                                            handleFetchSuccess(data2.data, event.target.value);
                                        }else{
                                        }
                                    } catch (err) {
                                        // handle error if needed
                                    }
                                }}
                                value={deviceNo}
                            >
                                {deviceNoOptions.map(item => (
                                    <MenuItem key={item} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid container spacing={1} direction="row">
                        <Grid item xs={3} width='20%' style={{ display: 'block', paddingTop: '0' }}>
                            <ul style={{ listStyle: 'none', paddingLeft: '0', margin: '0' }}>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('デマンド現在値')} style={activeRef === 1 ? liStyles : liStylesNormal}>デマンド現在値</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(demandCurrentDataFetchId, 'デマンド現在値')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledDemandCurrentDataRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledDemandCurrentDataRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('デマンド設定値')} style={activeRef === 2 ? liStyles : liStylesNormal}>デマンド設定値</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(demandSettingDataFetchId, 'デマンド設定値')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledDemandSettingDataRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledDemandSettingDataRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <li onClick={() => scrollTo('デマンド開始終了変更')} style={activeRef === 3 ? liStyles : liStylesNormal}>デマンド開始終了変更</li>
                                <li onClick={() => scrollTo('測定値開始終了変更')} style={activeRef === 4 ? liStyles : liStylesNormal}>測定値開始終了変更</li>                                
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('Connection情報')} style={activeRef === 5 ? liStyles : liStylesNormal}>Connection情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(connectionInformationFetchId, 'Connection情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledConnectionInformationRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledConnectionInformationRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('漏電情報')} style={activeRef === 6 ? liStyles : liStylesNormal}>漏電情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(leakageInformationFetchId, '漏電情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledLeakageInformationRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledLeakageInformationRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('軽漏電設定')} style={activeRef === 7 ? liStyles : liStylesNormal}>軽漏電設定</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(lightLeakageSettingFetchId, '軽漏電設定')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledLightLeakageSettingRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledLightLeakageSettingRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('重漏電設定')} style={activeRef === 8 ? liStyles : liStylesNormal}>重漏電設定</li>
                                    <IconButton aria-label="refresh" onClick={() => handleRefreshGroup(heavyEarthLeakageSettingFetchId, '重漏電設定')} disabled={numberRefreshAll > 0 || disabledHeavyEarthLeakageSettingRefresh} style={{ height: '24px' }}>
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledHeavyEarthLeakageSettingRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('30分電力量要求')} style={activeRef === 21 ? liStyles : liStylesNormal}>30分電力量要求</li>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('時間確認')} style={activeRef === 9 ? liStyles : liStylesNormal}>時間確認</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(confirmTimeFetchId, '時間確認')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledConfirmTimeRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledConfirmTimeRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('SoftVersion情報')} style={activeRef === 20 ? liStyles : liStylesNormal}>SoftVersion情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(softVersionDataFetchId, 'SoftVersion情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledSoftVersionDataRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledSoftVersionDataRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('Io/Ior設定情報')} style={activeRef === 10 ? liStyles : liStylesNormal}>Io/Ior設定情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(settingInformationFetchId, 'Io/Ior設定情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledSettingInformationRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledSettingInformationRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('PhaseAngle情報')} style={activeRef === 11 ? liStyles : liStylesNormal}>PhaseAngle情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(phaseAngleInformationFetchId, 'PhaseAngle情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledPhaseAngleInformationRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledPhaseAngleInformationRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('軽漏電流超過・復帰時間')} style={activeRef === 12 ? liStyles : liStylesNormal}>軽漏電流超過・復帰時間</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(excessLightLeakageCurrentFetchId, '軽漏電流超過・復帰時間')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledExcessLightLeakageCurrentRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledExcessLightLeakageCurrentRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('重漏電流超過・復帰時間')} style={activeRef === 13 ? liStyles : liStylesNormal}>重漏電流超過・復帰時間</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(excessHeavyLeakageCurrentFetchId, '重漏電流超過・復帰時間')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledExcessHeavyLeakageCurrentRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledExcessHeavyLeakageCurrentRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>

                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('最大漏電')} style={activeRef === 14? liStyles : liStylesNormal}>最大漏電</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(maximumEarthLeakageFetchId, '最大漏電')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledMaximumEarthLeakageRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledMaximumEarthLeakageRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('DeviceName')} style={activeRef === 15 ? liStyles : liStylesNormal}>DeviceName</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(deviceNameFetchId, 'DeviceName')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledDeviceNameRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledDeviceNameRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('LocationName')} style={activeRef === 16 ? liStyles : liStylesNormal}>LocationName</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(locationNameFetchId, 'LocationName')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledLocationNameRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledLocationNameRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('Connection設定情報')} style={activeRef === 17 ? liStyles : liStylesNormal}>Connection設定情報</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(connectionConfigInfoFetchId, 'Connection設定情報')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledConnectionConfigInfoRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledConnectionConfigInfoRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                                <div style={menuStyles}>
                                    <li onClick={() => scrollTo('4G LTE設定')} style={activeRef === 18 ? liStyles : liStylesNormal}>4G LTE設定</li>
                                    <IconButton
                                        aria-label="refresh"
                                        onClick={() => handleRefreshGroup(data4GLteSettingFetchId, '4G LTE設定')}
                                        disabled={disableAllRefeshButton || numberRefreshAll > 0 || disabledData4GLteSettingRefresh}
                                        style={{ height: '24px' }}
                                    >
                                        <CachedIcon style={disableAllRefeshButton || numberRefreshAll > 0 || disabledData4GLteSettingRefresh ? disabledRefreshAllBtnStyle : enableRefreshAllBtnStyle} />
                                    </IconButton>
                                </div>
                            </ul>
                        </Grid>
                        <Grid item xs={9} style={{ height: 'calc(100vh - 100px - 140px - 160px)', minHeight: '500px', overflowY: 'auto', paddingRight: '10px' }} onScroll={handleScroll}>
                            <div>
                                <div ref={myRef1}>
                                    <DemandCurrentData_TJ360VersionDevice
                                        defaultData={demandCurrentData}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isRefreshGroup={demandCurrentDataRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        deviceNo={deviceNo}
                                        centralId={device?.centralid ?? ''}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </DemandCurrentData_TJ360VersionDevice>
                                </div>
                                <div ref={myRef2}>
                                    <DemandSettingData_TJ360VersionDevice
                                        defaultData={demandSettingData}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isRefreshGroup={demandSettingDataRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        deviceNo={deviceNo}
                                        centralId={device?.centralid ?? ''}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </DemandSettingData_TJ360VersionDevice>
                                </div>
                                <div ref={myRef3}>
                                    <DemandChangeStartEnd_TJ360VersionDevice
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setDemandChangeStartEnd={((isLoading: boolean) => setDemandChangeStartEnd(isLoading))}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        demandStartEndInfo={demandStartEndInfo}
                                        deviceNo={deviceNo}
                                        centralId={device?.centralid ?? ''}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </DemandChangeStartEnd_TJ360VersionDevice>
                                </div>
                                <div ref={myRef4}>
                                    <ChangeMeasurentStartedEnd_TJ360VersionDevice
                                        mainid={`${id}`}
                                        title={"測定値開始終了変更"}
                                        device_no={deviceNo}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setChangeMeasurentStartedEnd={((isLoading: boolean) => setDemandChangeStartEnd(isLoading))}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        measurementInfo={measurementInfo}
                                        deviceNo={deviceNo}
                                        centralId={device?.centralid ?? ''}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </ChangeMeasurentStartedEnd_TJ360VersionDevice>
                                </div>
                                <div ref={myRef5}>
                                    <LoRaConnectionStatus_TJ360VersionDevice
                                        defaultData={connectionInformation}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={loRaConnectionStatusRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    />
                                </div>
                                <div ref={myRef6}>
                                    <LeakageInformation_TJ360VersionDevice
                                        defaultData={leakageInformation}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={leakageInformationRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </LeakageInformation_TJ360VersionDevice>
                                </div>
                                <div ref={myRef7}>
                                    <LightLeakageSetting_TJ360VersionDevice
                                        defaultData={lightLeakageSetting}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={lightLeakageSettingRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </LightLeakageSetting_TJ360VersionDevice>
                                </div>
                                <div ref={myRef8}>
                                    <HeavyEarthLeakageSetting_TJ360VersionDevice
                                        defaultData={heavyEarthLeakageSetting}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={heavyEarthLeakageSettingRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </HeavyEarthLeakageSetting_TJ360VersionDevice>
                                </div>
                                <div ref={myRef30MinutesPowerRequirement}>
                                    <Cpn30MinutePowerConsumption_TJ360VersionDevice
                                        defaultData={thirtyMinutesPowerConsumption}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isRefreshGroup={confirmTimeRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isEdit={isEdit}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        setIsEdit={handleSetIsEdit}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </Cpn30MinutePowerConsumption_TJ360VersionDevice>
                                </div>
                                <div ref={myRef9}>
                                    <ConfirmTime_TJ360VersionDevice
                                        defaultData={confirmTime}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isRefreshGroup={confirmTimeRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isEdit={isEdit}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        setIsEdit={handleSetIsEdit}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </ConfirmTime_TJ360VersionDevice>
                                </div>
                                <div ref={myRefSoftVersion}>
                                    <SoftVersionData_TJ360VersionDevice
                                        defaultData={softVersion}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isRefreshGroup={softVersionDataRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </SoftVersionData_TJ360VersionDevice>
                                </div>
                                <div ref={myRef10}>
                                    <SettingInformation_TJ360VersionDevice
                                        defaultData={settingInformation}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={settingInformationRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </SettingInformation_TJ360VersionDevice>
                                </div>
                                <div ref={myRef11}>
                                    <PhaseAngleInformation_TJ360VersionDevice
                                        defaultData={phaseAngleInformation}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={phaseAngleInformationRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </PhaseAngleInformation_TJ360VersionDevice>
                                </div>
                                <div ref={myRef12}>
                                    <ExcessLightLeakageCurrent_TJ360VersionDevice
                                        defaultData={excessLightLeakageCurrent}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={excessLightLeakageCurrentRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </ExcessLightLeakageCurrent_TJ360VersionDevice>
                                </div>
                                <div ref={myRef13}>
                                    <ExcessHeavyLeakageCurrent_TJ360VersionDevice
                                        defaultData={excessHeavyLeakageCurrent}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={excessHeavyLeakageCurrentRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </ExcessHeavyLeakageCurrent_TJ360VersionDevice>
                                </div>
                                <div ref={myRef14}>
                                    <MaximumEarthLeakage_TJ360VersionDevice
                                        defaultData={maximumEarthLeakage}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={maximumEarthLeakageRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </MaximumEarthLeakage_TJ360VersionDevice>
                                </div>
                                <div ref={myRef15}>
                                    <DeviceName_TJ360VersionDevice
                                        defaultData={deviceName}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={deviceNameRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </DeviceName_TJ360VersionDevice>
                                </div>
                                <div ref={myRef16}>
                                    <LocationName_TJ360VersionDevice
                                        defaultData={locationName}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={locationNameRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </LocationName_TJ360VersionDevice>
                                </div>
                                <div ref={myRef17}>
                                    <ConnectionConfigInfo_TJ360VersionDevice
                                        defaultData={connectionConfigInfo}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isRefreshGroup={connectionConfigInfoRefresh}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isEdit={isEdit}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        setIsEdit={handleSetIsEdit}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    ></ConnectionConfigInfo_TJ360VersionDevice>
                                </div>
                                <div ref={myRef18}>
                                    <Cpn4GLteSetting_TJ360VersionDevice
                                        defaultData={data4GLteSetting}
                                        mainid={`${id}`}
                                        isRefreshAllBegin={numberRefreshAll}
                                        isRefreshAllCompleted={handleRefreshAll}
                                        loadingRefreshAll={loadingRefreshAll}
                                        isEdit={isEdit}
                                        setIsEdit={handleSetIsEdit}
                                        setRefreshGroup={handleSetDisabledRefreshAll}
                                        isRefreshGroup={data4GLteSettingRefresh}
                                        setDisabledRefreshGroupBtn={handleSetDisabledRefreshGroupBtn}
                                        isDisbleRefeshBtn={disableAllRefeshButton}
                                        isDisbleUpdateBtn={disableAllUpdateButton}
                                        centralId={device?.centralid ?? ''}
                                        deviceNo={deviceNo}
                                        isRefreshSuccessDeviceNo={isRefreshSuccessDeviceNo}
                                    >
                                    </Cpn4GLteSetting_TJ360VersionDevice>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card >
            {
                openDialog ? (
                    <>
                        <ConfirmTimeDialog
                            onOK={(data) => {
                                handleEditOk(data);                            
                            }}
                            onCancel={() => {
                                setOpenDialog(false);
                            }}
                            initialValue={confirmTime}
                        />
                    </>
                ) : (
                    <div />
                )
            }
            <FetchHelper fetchId={updateConfirmTimeFetchId} onComplete={(success, data, error) => success ? handleUpdateSuccess(success, data, error) : handleUpdateError(success, data, error)} />
            <div>
                <Stack direction='row' justifyContent="flex-end" spacing={2} width="85%" margin="10px auto 0">
                    <Button color="inherit" variant="contained" onClick={handleCancel}>キャンセル</Button>
                </Stack>
            </div>
        </>
    );
};

const mapStateToProps = (state: ApplicationState) => ({
    fetchStateMenu: selectors.getFetchState(
        state,
        menusFetchId
    ) as FetchState,
});

const mapDispatchToProps = {
    onUpdate: (data: any) => actionCreators.fetch(updateConfirmTimeFetchId, `/polling-nrf/set?code=PP`, 'POST', data, false, true),
    onSearch: (mainid: string, device_no: string) => actionCreators.fetch("CACHE_FETCH", `/polling-nrf/cache?mainid=${mainid}&device_no=${device_no}`, 'GET', null),
    onCancel: () => push(RoutePath.DeviceList),
    onError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "装置情報",
            body: "装置情報が取得出来ません。",
        }),
    onGetAuthRole: () => actionCreators.fetch(menusFetchId, `/master/menus/get`, 'GET', null),
    onUpdateSuccess: () =>
        actionCreators.showMessage({
            type: "info",
            title: "時間確認変更",
            body: "時間確認を更新しました。",
        }),
    onUpdateError: (success: boolean, data: any, error: any) =>
        actionCreators.showMessage({
            type: "error",
            title: "時間確認変更",
            body: "時間確認を変更できませんでした。",
        }),
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PollingTopicDetails_TJ360VersionDevice as any);

